import { render, staticRenderFns } from "./instagram-insights.vue?vue&type=template&id=d6e3596a"
import script from "./instagram-insights.vue?vue&type=script&lang=js"
export * from "./instagram-insights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports